<template>
  <div>
    <!-- Search Input -->
    <!-- Inline Search Form -->
     Page: {{ currentPage }}, Total {{ totalRows }}, Items: {{itemsPerPage}}
    <b-form inline class="my-3">
      <b-form-group
        label="Rechercher"
        label-for="search-input"
        class="mb-0"
      >
        <div class="input-wrapper">
          <!-- Search Input -->
          <b-form-input
            id="search-input"
            v-model="searchText"
            placeholder="Un nom de société, un SIRET..."
            ref="searchInput"
          ></b-form-input>

          <!-- Clear Button as a Cross -->
          <span
            v-if="searchText"
            class="clear-cross"
            @click="clearSearch"
          >&times;</span>
        </div>
      </b-form-group>

      <!-- Search Button -->
      <b-button
        variant="primary"
        @click="onSearch"
      >
        Chercher
      </b-button>
      <!-- Grouped Toggle -->
      <b-form-checkbox
        v-model="grouped"
        class="ml-2"
        >
        <!-- @change="onToggleGrouped" -->
        Grouped
      </b-form-checkbox>
      <label class="ml-2">
      </label>
    </b-form>


    <!-- Pagination -->
    <!-- <b-pagination
      v-model="currentPage"
      :total-rows="totalRows"
      :per-page="itemsPerPage"
    ></b-pagination> -->
    <pagination
      v-model="currentPage"
      :total-rows="totalRows"
      :items-per-page="itemsPerPage"
    ></pagination>

    <!-- Table with expandable rows :per-page="itemsPerPage" -->
    <b-table
      :items="filteredItems"
      :fields="fields"
      :current-page="currentPage"
      
      :busy.sync="isBusy"
      responsive
      hover
    >
      <template #cell(id)="data">
        <b-button v-if="data.item.children && data.item.children.length>0" size="sm" @click="toggleRow(data.item)">
          {{ data.item._showDetails ? '➖📂' : '➕📁' }}
        </b-button>
      </template>
      
      <template #cell(name)="data">
            <router-link :to="urlWithRedirect('/admin/company/'+data.item._id)">{{data.item.name}}</router-link>
      </template>

      <template #row-details="row">
        <b-table
          small
          :items="row.item.children"
          :fields="childFields"
          thead-class="b-none"
        >
          <template #cell(name)="data">
                <router-link :to="urlWithRedirect('/admin/company/'+data.item._id)">{{data.item.name}}</router-link>
          </template>
      
        </b-table>
      </template>
    </b-table>

    <!-- Pagination -->
    <!-- <b-pagination
      v-model="currentPage"
      :total-rows="totalRows"
      :per-page="itemsPerPage"
    ></b-pagination> -->
    <div class="row">
    <div class="col-2">Nb d'éléments par page</div>
    <b-form-select
        v-model="itemsPerPage"
        :options="selectItemsPerPage"
        class="col-2"
      ></b-form-select>
    </div>
  </div>
</template>
<script>
import StatusIcon from '../../components/StatusIcon.vue';
import Pagination from '../../components/Pagination.vue';
const Business = require('ppe-business');
import common from '../common/pages.js';


export default {
  components: {
    StatusIcon,
    Pagination
  },

  data() {
    return { 
      isMounted:false,
      items: [],
      searchText: '',
      grouped:true,
      fields: [
        { key: '_index', label: '#', 'class': 'text-right', width:'10px' },
        { key: 'id', label: '>', 'class': 'text-center', width:'30px' },
        { key: 'name', label: 'Entité', sortable: true, 'class': 'text-left' },
        { key: 'city', label: 'Ville', sortable: true },
      ],
      childFields: [
      { key: 'name', 'class':'ml-indented col-9' },
      { key: 'city', width:'100%'},
      ],
      totalRows: 0,
      itemsPerPage: 10,
      currentPage: 1,
      isBusy: false,
      selectItemsPerPage: [
        { value: 5, text: '5' },
        { value: 10, text: '10' },
        { value: 20, text: '20' },
        { value: 50, text: '50' },
        { value: 100, text: '100' },
      ]
    }
  },

  computed: {
    filteredItems() {
      /*var items = []
      
      if (this.searchText) {
        items = this.items.filter(item =>
          item.name.toLowerCase().includes(this.searchText.toLowerCase())
        );
      } else {
        items = this.items;
      }

      return items;*/
      return this.items;
    },
  },

  mounted() {
      if(this.isMounted) return
      console.log("MOUNTED");
      this.fetchParamsFromUrl();
      //this.updateUrlParams();
      this.fetchData();
      this.isMounted = true
    },

  watch: {
    currentPage() {
      this.updateUrlParams();
      this.fetchData();
    },

    itemsPerPage() {
      this.currentPage = 1; // How to avoir currentPage() to be called ?
      this.updateUrlParams();
      this.fetchData();
    },

    searchText() {
      //this.currentPage = 1; // Reset to the first page on new search
      //this.updateUrlParams();
      //this.fetchData();
    },
    grouped() {
      this.currentPage = 1; // Reset to the first page on new search
      this.updateUrlParams();
      this.fetchData();
      this.$refs.searchInput.focus(); // Refocus the input after clearing
    },
  },

  methods: {
    ...common.methods,

    toDate(apiDate) {
      return Business.toDate(apiDate);
    },

    toggleRow(item) {
      item._showDetails = !item._showDetails;
    },

    clearSearch() {
      this.searchText = '';
      this.$refs.searchInput.focus(); // Refocus the input after clearing
      this.fetchData(); // Optionally refresh data upon clearing the search
    },

    onSearch() {
      console.log("onSearch");
      this.currentPage = 1;
      this.fetchData();
    },
    
    changeItemsPerPage() {
      this.currentPage = 1;
      console.log("changeItemsPerPage", this.currentPage, this.itemsPerPage)
      this.fetchData()
    },

    updateUrlParams() {
      this.$router.replace({
        query: {
          ...this.$route.query,
          /*currentPage: this.currentPage,
          itemsPerPage: this.itemsPerPage,
          searchText: this.searchText,
          grouped: this.grouped?'true':'false',*/
        }
      });
    },

    fetchParamsFromUrl() {
      const { currentPage, itemsPerPage, searchText, grouped } = this.$route.query;
      if (currentPage) {
        this.currentPage = parseInt(currentPage, 10);
      }
      if (itemsPerPage) {
        this.itemsPerPage = parseInt(itemsPerPage, 10);
      }
      if (searchText) {
        this.searchText = searchText;
      }
      if( grouped ) {
        this.grouped = (grouped !== 'false')
      }
    },

    fetchData() {
      if(this.isBusy) return;
      this.isBusy = true;
      this.$http.get('/admin/companytree', { params: { page: this.currentPage, limit: this.itemsPerPage, search: this.searchText, grouped:this.grouped } })
        .then(response => {
          console.log("/admin/companytree", response)
          this.items = response.data.items.map( (item, index) => {
            return {
              ...item,
              _rowVariant:Business.getStatusClass(item._status),
              _showDetails: false,
              _index: (this.currentPage - 1) * this.itemsPerPage + index + 1
            };
          });
          this.totalRows = response.data.total;
          this.totalInitial = this.totalRows;
          this.isBusy = false;
        })
        .catch((err) => {
          this.isBusy = false;
          let error = JSON.parse(JSON.stringify(err));
          swal("Erreur", JSON.stringify(err.response ? err.response.data : error.message), "error");
        });
    }
  }
}
</script>

<style>
.table > tbody > tr > td:last-child {
  width: auto;
}
.ml-indented {
    padding-left: 20% !important; /* Adjust the value as needed */
}
.b-none {
  display: none !important;
}

.input-wrapper {
  position: relative;
  display: inline-block;
}

.clear-cross {
  position: absolute;
  right: 10px;
  top: 50%;
  transform: translateY(-50%);
  cursor: pointer;
  background: transparent;
  border: none;
  font-size: 1.2em;
  color: #495057;
  user-select: none;
}
.clear-cross:hover {
  color: #dc3545; /* Example hover color */
}
</style>